import { For } from 'solid-js'

import { useI18n } from '../../i18n'
import type { EffortBucketSize } from './metricViewUtils'

type BucketSizeChipsProps = {
   value: EffortBucketSize
   onChange: (size: EffortBucketSize) => void
}

const BUCKET_SIZES: readonly EffortBucketSize[] = ['week', 'month']

/**
 * Renders the "week · month" chips that pick the effort chart's bucket size.
 *
 * @param props - The active size and change handler.
 * @returns The chip row element.
 */
const BucketSizeChips = (props: BucketSizeChipsProps) => {
   const t = useI18n()

   return (
      <div class="flex flex-wrap items-center gap-2" id="effort-bucket-chips">
         <For each={BUCKET_SIZES}>
            {size => (
               <button
                  type="button"
                  class="px-3 py-1 rounded-full text-xs border transition capitalize"
                  classList={{
                     'border-accent-strong bg-accent-strong/20 text-ink':
                        props.value === size,
                     'border-edge bg-surface-raised text-ink-secondary hover:bg-surface-control':
                        props.value !== size,
                  }}
                  onClick={() => props.onChange(size)}
               >
                  {t(size)}
               </button>
            )}
         </For>
      </div>
   )
}

export default BucketSizeChips
